module.exports = __webpack_public_path__ + "static/rostelekom-4904743646b0dc6eacb780015cc19ff0.jpg";